// SHA-1 of a string, as 40 lowercase hex digits. Names uploaded images
// (assets/<sha1>.png), so it must match what crypto-js's SHA1(str).toString()
// gave: the UTF-8 bytes of the string, hashed, as hex.
export async function getSha1HexFromStringP(str) {
  const digest = await crypto.subtle.digest(
    "SHA-1",
    new TextEncoder().encode(str)
  );
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");
}
